import logoV from '../../assets/Logo_Vertical_Dark.png';
import logoH from '../../assets/Logo_Horizontal_Dark.png';
import logoM3tas from '../../assets/logo.png';
import Bandeira from '../../assets/Bandeiras.png';
import { Logo, LogoH, LogoV, BandeiraCartao} from './styles';

import logoSampleclient from '../../assets/logo-sampleclient.png';
import logordcorretora from '../../assets/logordcorretora.png';
import logordcorretoraH from '../../assets/logordcorretoraH.png';
import logorbmseguros from '../../assets/logo-rbmseguros.png';
import logohectaresseguros from '../../assets/logo-hectaresseguros.png';
import logocanolaseguros from '../../assets/logo-canolaseguros.png';
import logocanolasegurosH from '../../assets/logo-canolasegurosH.png';

/* Ambientes Coruja */
import logoCoruja from '../../assets/CORUJA_LOGO.png';
import logocorujaclube from '../../assets/logo-corujaclube.png';
/**/ 

/*
Horizontal 3,2% de proporção
800 x 250 ou 600 x 185
*/

const logosRequired = {
    logoV,
    logoH,
    logoM3tas,
    Bandeira,
    logoSampleclient,
    logordcorretora,
    logordcorretoraH,
    logorbmseguros,
    logohectaresseguros,
    logocanolaseguros,
    logocanolasegurosH,

    /* Ambientes Coruja */
    logoCoruja,
    logocorujaclube,
}


export const LogoMetas = () => 
    <Logo src={logoM3tas} 
          layoutId="logo" 
          transition={{ duration: 1 }} />;

// Login
export const LogoVertical = () => 
    <LogoV src={logosRequired[localStorage.getItem("logoVertical")] || logoM3tas} 
           layoutId="logo" 
           transition={{ duration: 1 }} />;

export const LogoHorizontal = () => 
    <LogoH src={logosRequired[localStorage.getItem("logoHorizontal")] || logoM3tas} 
           layoutId="logo" 
           transition={{ duration: 1 }} />;

export const LogoImg = () => 
    <Logo src={logosRequired[localStorage.getItem("logoImg")] || logoM3tas} 
          layoutId="logo" 
          transition={{ duration: 1 }} />;

export const Bandeiras = () => 
    <BandeiraCartao src={logosRequired[localStorage.getItem("logoBandeiras")]} 
                    layoutId="Bandeira" 
                    transition={{ duration: 1 }} />;

